export default function ProgramsHero() {
  return (
    <section className="relative min-h-[560px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Northern%20Nigeria%20community%20health%20outreach%20scene%2C%20diverse%20group%20of%20people%20gathered%20outdoors%20in%20Kano%2C%20healthcare%20workers%20and%20community%20members%2C%20purple%20awareness%20banners%2C%20warm%20golden%20afternoon%20light%2C%20wide%20landscape%20shot%2C%20hopeful%20and%20energetic%20atmosphere%2C%20authentic%20African%20community%20setting&width=1600&height=900&seq=prghero01&orientation=landscape"
        alt="IKIRU Programs"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A0A1E]/70 via-[#2D0A35]/60 to-[#1A0A1E]/80"></div>
      <div className="relative z-10 w-full text-center px-6 md:px-10 pt-28 pb-16">
        <span className="inline-block text-xs font-semibold uppercase tracking-[4px] text-purple-300 mb-5">
          What We Do
        </span>
        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight max-w-4xl mx-auto">
          Programs Built for <span className="text-[#C084FC]">Real Impact</span>
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10">
          Six evidence-informed programs anchored in Kano and amplified nationally through Abuja — designed to reduce stigma, improve access to care, and restore dignity for persons living with epilepsy across Northern Nigeria.
        </p>
        <div className="flex flex-wrap justify-center gap-6">
          {[
            { icon: 'ri-map-pin-2-line', label: 'Kano & Abuja' },
            { icon: 'ri-group-line', label: '6 Core Programs' },
            { icon: 'ri-seedling-line', label: '12-Month Launch Plan' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-5 py-2.5">
              <i className={`${stat.icon} text-[#C084FC] text-base`}></i>
              <span className="text-white text-sm font-medium">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
